"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfernoAbilityHandler = exports.InfernoActorAbilityFactory = exports.InfernoAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Burning_1 = require("../../core/effects/core/Burning");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class InfernoAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Inferno;
        this.__typeName = "Inferno";
    }
}
exports.InfernoAbilityArgs = InfernoAbilityArgs;
let InfernoActorAbilityFactory = class InfernoActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Inferno", "OneEnemies", 4);
    }
};
InfernoActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Inferno")
], InfernoActorAbilityFactory);
exports.InfernoActorAbilityFactory = InfernoActorAbilityFactory;
let InfernoAbilityHandler = class InfernoAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 100)
            ],
            onHit(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "FireTornado"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new Burning_1.BurningEffectArgs("Focus", 10),
                });
            }
        });
    }
};
InfernoAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Inferno)
], InfernoAbilityHandler);
exports.InfernoAbilityHandler = InfernoAbilityHandler;
